import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ProfileComponent} from "./profile/profile.component";
import {CashierComponent} from "./cashier/cashier.component";
import {JackpotsComponent} from "./jackpots/jackpots.component";
import {authGuard} from "../guards/auth.guard";
import {UserPromotionsComponent} from "./user-promotions/user-promotions.component";

const routes: Routes = [
  { path: '', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'cashier', component: CashierComponent, canActivate: [authGuard] },
  { path: 'promotions', component: UserPromotionsComponent, canActivate: [authGuard] },
  // { path: 'jackpots', component: JackpotsComponent},
  { path: '**', component: ProfileComponent, canActivate: [authGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
